import { IconButton, Link, Stack, Tooltip, Typography } from "@mui/material";
import { grey } from '@mui/material/colors';
import { DataGrid } from "@mui/x-data-grid";
import VisibilityIcon from '@mui/icons-material/Visibility';
import useModal from "../../common/hooks/useModal";
import clientService from "../../services/client.service";
import { useSnackbar } from 'notistack'
import { useHistory } from "react-router-dom";
import { formatDate } from "../../helpers";

export const HistoricalAlbaranesTable = ({ rowsState, setRowsState }) => {
  const modal = useModal();
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory();

  const { rows, loading, total, pageSize } = rowsState;

  const columns = [
    {
      headerName: "Albarán",
      title: "numero_albaran_dev",
      field: "numero_albaran_dev",
      flex: 1,
      minWidth: 100,
      // Numero de DEVOLUCION, con caida al de reparto cuando aun no ha llegado el fichero de
      // cabecera y la fila la creo el detalle. Ver AlbaranesTable.
      renderCell: (params) => (
        <Stack>
          <Link color="primary" underline="hover" href={`/historical-albaran/${params.row.id}`}>
            {params.row.numero_albaran_dev || params.row.numero_albaran}
          </Link>
        </Stack>
      ),
    },
    {
      headerName: "Fecha",
      title: "fecha_albaran",
      field: "fecha_albaran",
      flex: 1,
      minWidth: 90,
      renderCell: (params) => (
        <Stack>
          <Typography variant="body2">
            {formatDate(new Date(params.value), "es-ES", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })}
          </Typography>
          <Typography variant="body2" color={grey[500]}>{params.row.card}</Typography>
        </Stack>
      ),
    },
    {
      headerName: "Devolución",
      field: "actions",
      type: "actions",
      width: 110,
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="Editar">
              <IconButton
                size="small"
                aria-label="Editar cliente"
                onClick={(evt) => history.push(`/historical-albaran/${cellValues.id}`)}
              >
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <div style={{ height: 470, width: "100%", marginBottom: 30 }}>
      <DataGrid
        density="standard"
        rows={rows}
        columns={columns}
        rowCount={total}
        pageSize={pageSize}
        rowsPerPageOptions={[pageSize]}
        pagination
        paginationMode="server"
        onPageSizeChange={(pageSize) =>
          setRowsState((prev) => ({ ...prev, pageSize }))
        }
        onPageChange={(page) => {
          setRowsState((prev) => ({ ...prev, page }));
        }}
        loading={loading}
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              No hay resultados
            </Stack>
          )
        }}
      />
    </div>
  );
};
